import {useRef, useEffect} from "react";
import {getNumberWithGap} from "../../helpers/general-functions";

export default function Countdown({timer = 0, onFinish}) {

    const timerRef = useRef(null);

    useEffect(() => {

        let minute = Math.floor(timer / 60);
        let second = timer % 60;

        const interval = setInterval(() => {
            if(second === 0) {
                if(minute === 0) {
                    clearInterval(interval);
                    onFinish()
                } else {
                    minute -= 1;
                    second = 59;
                }
            } else {
                second -= 1;
            }

            if(timerRef.current) {
                timerRef.current.innerText = `${getNumberWithGap(minute)}:${getNumberWithGap(second)}`
            }

        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [timer]); // eslint-disable-line

    return (
        <time className="min-w-[2.75rem] w-11 inline-block" ref={timerRef}>00:00</time>
    )
}
